import type { DocumentServicesObject } from '@wix/document-services-types';

export function isTPAPage(
  dm: DocumentServicesObject,
  componentType: string,
): boolean {
  return (
    dm.tpa.isTpaSectionByCompType(componentType) ||
    dm.tpa.isTpaMultiSectionByCompType(componentType)
  );
}
